module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-email-service-content"
  }, [_c('a', {
    staticClass: "link-email-service-create",
    attrs: {
      "data-no-turbolink": "true"
    },
    on: {
      "click": function($event) {
        _vm.modalOpen('edit-account');
        _vm.resetActiveAccount();
      }
    }
  }, [_c('i', {
    staticClass: "icon-email-service icon-kp-mail-new"
  }), _vm._v(" "), _c('div', {
    staticClass: "email-service-create-text"
  }, [_vm._v(_vm._s(_vm.$t('account.actions.new')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f87ebde","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Account/components/EmptyBoard.vue
// module id = 267
// module chunks = 1